const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/admin/organizations.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/admin/organizations.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { OrganizationInventorySkeleton } from '@/features/organization-management/components/OrganizationInventorySkeleton';
import { organizationsInfiniteQuery } from '@/features/organization-project-picker/services/organizationProjectQueries';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Gated in `beforeLoad` as the exact `organizations` domain console.
 *
 * The loader prefetches only the organization inventory, so this route owns the
 * loading skeleton (`pendingComponent`) and error UI (`errorComponent`) for the
 * org list; the page reads it via a suspense query. Each org's projects load
 * lazily when its row is expanded (a per-org suspense query inside the table),
 * so we no longer fan out to every org's projects up front.
 */
export const Route = createFileRoute('/_authenticated/_app/admin/organizations')({
  beforeLoad: requireCapabilities(has => has('organizations.list')),
  loader: ({
    context
  }) => context.queryClient.ensureInfiniteQueryData(organizationsInfiniteQuery()),
  pendingComponent: OrganizationInventorySkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});